var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M24.835 4.5V26.9131L24.2842 26.4414C23.7104 25.9496 22.9794 25.6798 22.2236 25.6797C21.4678 25.6797 20.736 25.9495 20.1621 26.4414L19.1123 27.3408L18.0625 26.4414C17.4885 25.9493 16.757 25.6787 16.001 25.6787C15.2449 25.6788 14.5134 25.9492 13.9395 26.4414L12.8896 27.3408L11.8398 26.4414C11.266 25.9497 10.5351 25.6797 9.7793 25.6797C9.02354 25.6797 8.29263 25.9497 7.71875 26.4414L7.16797 26.9131V4.5H24.835Z",
    fill: "#E8E8E8",
    stroke: "#465867"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 4H25.3346V28L23.9586 26.8213C23.4753 26.4071 22.8598 26.1794 22.2233 26.1794C21.5868 26.1794 20.9713 26.4071 20.488 26.8213L19.112 28L17.7373 26.8213C17.2539 26.4068 16.6381 26.1789 16.0013 26.1789C15.3645 26.1789 14.7487 26.4068 14.2653 26.8213L12.8906 28L11.5146 26.8213C11.0313 26.4071 10.4158 26.1794 9.7793 26.1794C9.14279 26.1794 8.52727 26.4071 8.04397 26.8213L6.66797 28V4ZM20.0013 9.33333H12.0013ZM20.0013 14.6667H12.0013ZM20.0013 20H14.668Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 9.33333H12.0013M20.0013 14.6667H12.0013M20.0013 20H14.668M6.66797 4H25.3346V28L23.9586 26.8213C23.4753 26.4071 22.8598 26.1794 22.2233 26.1794C21.5868 26.1794 20.9713 26.4071 20.488 26.8213L19.112 28L17.7373 26.8213C17.2539 26.4068 16.6381 26.1789 16.0013 26.1789C15.3645 26.1789 14.7487 26.4068 14.2653 26.8213L12.8906 28L11.5146 26.8213C11.0313 26.4071 10.4158 26.1794 9.7793 26.1794C9.14279 26.1794 8.52727 26.4071 8.04397 26.8213L6.66797 28V4Z",
    stroke: "#465867",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.dbc4ef78d6bccccef26fa0a440e47847.svg";
export { ForwardRef as ReactComponent };